'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageDescription = function (_BcReactComponent) {
  _inherits(PageDescription, _BcReactComponent);

  function PageDescription() {
    _classCallCheck(this, PageDescription);

    return _possibleConstructorReturn(this, (PageDescription.__proto__ || Object.getPrototypeOf(PageDescription)).apply(this, arguments));
  }

  _createClass(PageDescription, [{
    key: 'getPageStart',
    value: function getPageStart() {
      var _props = this.props,
          page = _props.page,
          pageSize = _props.pageSize,
          numberOfItems = _props.numberOfItems;

      var index = page * pageSize + 1;
      return _lodash2.default.clamp(index, 1, numberOfItems);
    }
  }, {
    key: 'getPageEnd',
    value: function getPageEnd() {
      var _props2 = this.props,
          page = _props2.page,
          pageSize = _props2.pageSize,
          numberOfItems = _props2.numberOfItems;

      var index = (page + 1) * pageSize;
      return _lodash2.default.clamp(index, 1, numberOfItems);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactIntl.FormattedMessage,
        {
          id: 'carousel_view_items',
          values: { start: this.getPageStart(), end: this.getPageEnd() } },
        function (message) {
          return _react2.default.createElement(
            _baseScreenReaderMessage2.default,
            { className: 'cp-page-description' },
            message
          );
        }
      );
    }
  }]);

  return PageDescription;
}(_baseBcReactComponent2.default);

exports.default = PageDescription;


PageDescription.propTypes = {
  page: _react.PropTypes.number,
  pageSize: _react.PropTypes.number,
  numberOfItems: _react.PropTypes.number
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/carousel-base/lib/components/PageDescription.component.js
// module id = 536
// module chunks = 1